import React from 'react';
import { getLabel } from '../../../InitData';
import { formatDate, getConfiguration, getCurrencyValue } from '../../utils';
import DetailedBalanceCss from './common-includes/DetailedBalanceCss';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';


function PosMonthlyCommReportReceipt(props){
	
	const opData = props.data;
	const header = opData.header;
	const previous = header.previous;
	const bodyRows = opData.body;
	const conf = getConfiguration();

	const fromTo = [getLabel('retail.from'), formatDate(header.fromDate, false).formatted_no_hour, getLabel('retail.to'), formatDate(header.toDate, false).formatted_no_hour].join(" ");
	
	function getFromToDisclaimer(label, fromTS, toTS){
		let result = label? label : '';
		result = result + " ("  + getLabel('general.from').toLowerCase();
		result = result + " " + formatDate(fromTS, false).formatted_no_hour;
		result = result + " " + getLabel('general.to').toLowerCase();
		result = result + " " + formatDate(toTS, false).formatted_no_hour;
		result = result + ")";
		return result;
	}

	return <>
		<DetailedBalanceCss />
		<body>
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={getLabel('retail.monthly_commission_report.title')}></ShopReceiptHeader>	
			<div> {fromTo.toUpperCase()} </div>
			<div> {getLabel('retail.shop_detailed_balance.pos_id')}: {opData.operator.shopId} </div>		
			<div className="footerBox">
				<div> 
					{getFromToDisclaimer(getLabel('retail.monthly_commission_report.balance_previous_month'), previous.inizio, previous.fine)}: 
					<span className="bold"> {getCurrencyValue(previous.saldo_prec, conf.cs.m, conf.cs.nd, conf.cs.ct)} </span>
				</div>
			</div>
			{
				Object.keys(bodyRows).map((key)=> {
					const weekRow = bodyRows[key];
					
					return <div className="footerBox" key={key}>
						<div className={"headerRow"}> 
							<div className={"weekDiscl"}> 
								{getFromToDisclaimer(getLabel('general.week') + ' ' + weekRow.week, weekRow.fromDate, weekRow.toDate)} 
							</div>
						</div>
						{
							weekRow['PSQF'] && 	<>
								<div className="operationMonospace cashAvailability">
			 						{getLabel('retail.protocol.psqf_desc')}: 
			 						{getCurrencyValue(weekRow['PSQF'].valore, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
								</div>	
							</>
						}
						{
							weekRow['PSV'] && 	<>
								<div className="operationMonospace cashAvailability">
			 						{getLabel('retail.protocol.psv_desc')}: 
			 						{getCurrencyValue(weekRow['PSV'].valore, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
								</div>	
							</>
						}
						
					</div>
				})
			}
			<div className="footerBox">
				<div className="operationMonospace cashAvailability"> 
					{getLabel('retail.monthly_commission_report.commission_monthly')}: 
					{getCurrencyValue(opData.footer.monthly.commissioni, conf.cs.m, conf.cs.nd, conf.cs.ct)}
				</div>
			</div>
			
		</body>
		
    </>;
}
export default PosMonthlyCommReportReceipt;